import { create } from "zustand";

import type { CurrentUser } from "./CurrentUser";

/**
 * 認証 UI 状態。
 *
 * - `initializing`: taskpane.tsx の bootstrap で getCurrentUser を呼ぶ前の暫定状態
 * - `unauthenticated`: 未認証 (Cookie なし / 期限切れ)
 * - `authenticated`: 認証済み
 * - `reauth-required`: API 呼び出しで 401 が出て refresh も失敗。再ログイン待ち
 */
export type AuthStatus = "initializing" | "unauthenticated" | "authenticated" | "reauth-required";

export type AuthState = {
    status: AuthStatus;
    user: CurrentUser | null;

    /** taskpane bootstrap / login 成功時に呼ぶ。 */
    setAuthenticated: (user: CurrentUser) => void;
    /** logout 完了時に呼ぶ。 */
    setUnauthenticated: () => void;
    /** API 401 + refresh 失敗時に呼ぶ。 */
    setReauthRequired: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
    status: "initializing",
    user: null,
    setAuthenticated: (user) => set({ status: "authenticated", user }),
    setUnauthenticated: () => set({ status: "unauthenticated", user: null }),
    setReauthRequired: () => set({ status: "reauth-required" }),
}));
